import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import React, { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AiFillDelete } from "react-icons/ai";
import { server } from "../../../common";
import useQuickLook from "../../../quicklook/useQuickLook";
import { useSelectAccess } from "../../../store/stateFunctions";

const swalalert = withReactContent(Swal);

const TotalIndustryUsers = () => {
  const user = useSelectAccess("Super Admin");
  const [data, setData] = useState([]);
  const displayFile = useQuickLook();

  useEffect(() => {
    getData();
  }, []);

  // Get
  const getData = () => {
    server
      .get("/register/getallorganization", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete
  const handleDelete = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/register/delete/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Event has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };
  return (
    <>
      <div className="container">
        <h2 className="text-center py-4">Total Industry Users</h2>
        <table class="table table-striped border">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Organization Name</th>
              <th scope="col">Email Id</th>
              <th scope="col">Contact No</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              return (
                <tr key={item.id}>
                  <th scope="row">{index + 1}</th>
                  <td>{item.organization_name}</td>
                  <td>{item.business_email}</td>
                  <td>{item.org_contact}</td>

                  {/* <td>
                    <div
                      className="btn banner text-white p-1"
                      onClick={() =>
                        displayFile(item.title, item.image, {
                          isImage: true,
                        })
                      }
                    >
                      View
                    </div>
                  </td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TotalIndustryUsers;
